import { createSelector } from "reselect";
const getConfigInfo = (state) => state && state.config;
const getSiteInfo = (state) => state && state["cbre-flow-site-location"].siteInfo;
const getSiteLocation = (state) => state && state["cbre-flow-site-location"];

export const getSite = createSelector([getSiteInfo], (siteInfo) => siteInfo);

export const getSiteId = createSelector([getSiteInfo], (siteInfo) => siteInfo.siteId);

export const RequestAccessUrl = createSelector(
  [getConfigInfo],
  (configInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/site-access-requests`
      : '',
);
export const getSiteInfoUrl = createSelector(
  [getConfigInfo],
  (configInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/site-info`
      : '',
);

export const setSiteInfoUrl = createSelector(
  [getConfigInfo],
  (configInfo) =>
    configInfo && configInfo.client && configInfo.client.flowApiUrl
      ? `${configInfo.client.flowApiUrl}api/site-info/update-users-site/`
      : '',
);

export const defaultSiteListInfo = createSelector([getSiteLocation], (siteLocation) => siteLocation.defaultSiteLists || []);